export default __webpack_public_path__ + "static/media/color-palette.bf0ad196.png";